/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Switch, Spin } from 'antd';
import { Loader2, ShieldAlert } from 'lucide-react';
import { get } from 'lodash';
import { fetchDsrLogsEHSIssues } from '../../redux/ehsIssues/action';
import './TechnicianLogSection.css';
import './EhsIssuesAndCorrectiveActions.css';

const EhsIssuesAndCorrectiveActions = (props) => {
  const {
    selectedProject,
    selectedData,
    isEHSIssuesLoading,
    ehsIssuesList,
    onFetchDsrlogsEHSIssues,
    dsrSowId,
  } = props;

  const [shift, setShift] = useState(0);

  useEffect(() => {
    onFetchDsrlogsEHSIssues({ selectedData, selectedProject, shift, sowId: dsrSowId });
  }, [selectedData, selectedProject, shift]);

  const handleSwitch = () => {
    setShift(!shift);
  };

  const rows = Array.isArray(ehsIssuesList) ? ehsIssuesList : [];
  const showList = ehsIssuesList[0]?.isSkipped == 0;

  return (
    <div className="h-100 overflow-y-hidden overflow-x-hidden inventory modern-dsr-ehs-readonly-host">
      <div className="modern-dsr-ehs-readonly-switch">
        <Switch
          checkedChildren="Day"
          unCheckedChildren="Night"
          defaultChecked
          onChange={handleSwitch}
        />
      </div>
      <div className="addTeamDetails modern-dsr-ehs-readonly">
        {showList ? (
          <Spin
            spinning={isEHSIssuesLoading}
            indicator={(
              <span className="modern-dsr-tech-log-spin" aria-hidden>
                <Loader2 className="modern-dsr-tech-log-spin-icon" size={28} strokeWidth={2} />
              </span>
            )}
          >
            <div className="modern-dsr-tech-log-section modern-dsr-ehs-usage" style={{ padding: '0 0 8px' }}>
              <div className="modern-dsr-tech-log-card">
                <div className="modern-dsr-tech-log-card-head">
                  <div className="modern-dsr-tech-log-card-title-block">
                    <div className="modern-dsr-tech-log-card-icon" aria-hidden>
                      <ShieldAlert size={22} strokeWidth={2} />
                    </div>
                    <div>
                      <h3 className="modern-dsr-tech-log-card-title">EHS issues &amp; corrective actions</h3>
                      <p className="modern-dsr-tech-log-card-sub">View logged issues and severity for the selected DSR (read-only).</p>
                    </div>
                  </div>
                </div>
                <div className="modern-dsr-tech-table" role="table" aria-label="EHS issues">
                  <div className="modern-dsr-tech-thead modern-dsr-ehs-ro-grid" role="row">
                    <div className="modern-dsr-tech-th" role="columnheader">Issue type</div>
                    <div className="modern-dsr-tech-th" role="columnheader">Severity</div>
                    <div className="modern-dsr-tech-th" role="columnheader">Comments / corrective action</div>
                  </div>
                  {rows.length === 0 ? (
                    <div className="modern-dsr-tech-empty">No EHS issues for this log.</div>
                  ) : (
                    rows.map((row, idx) => (
                      <div
                        key={row.id != null ? row.id : `ehs-row-${idx}`}
                        className="modern-dsr-tech-row modern-dsr-ehs-ro-grid"
                        role="row"
                      >
                        <div className="modern-dsr-tech-td" role="cell" title={row.name}>
                          {row.name}
                        </div>
                        <div
                          className="modern-dsr-tech-td modern-dsr-ehs-ro-td--muted"
                          role="cell"
                        >
                          {row.major == 0 && row.minor == 0
                            ? '—'
                            : row.major
                            ? 'Major'
                            : 'Minor'}
                        </div>
                        <div className="modern-dsr-tech-td" role="cell" title={row.comments}>
                          {row.comments}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </Spin>
        ) : (
          <div className="modern-dsr-ehs-skipped">EHS Issue Skipped</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ ehsIssuesReducer }) => {
  const ehsIssuesList = get(ehsIssuesReducer, 'ehsIssuesList', []);
  const isEHSIssuesLoading = get(ehsIssuesReducer, 'isEHSIssuesLoading', false);
  return {
    ehsIssuesList,
    isEHSIssuesLoading,
  };
};

const mapDispatchToProps = {
  onFetchDsrlogsEHSIssues: fetchDsrLogsEHSIssues,
};

export default connect(mapStateToProps, mapDispatchToProps)(EhsIssuesAndCorrectiveActions);
